<template>
  <div class="PSelect">
    <select
      v-bind:value="value"
      v-on:input="$emit('input', $event.target.value)"
      v-on:change="$emit('change')"
    >
      <option
        v-for="item in items"
        :key="item"
        :value="item"
      >{{ item }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: "PSelect",
  props: {
    items: {
      type: Array,
      require: true
    },
    value: {
      type: String,
      require: true
    },
    width: {
      type: String,
      require: true
    }
  },
  computed: {}
}
</script>

<style lang="scss" scoped>
.PSelect > select {
  position: relative;
  width: 315px;
  margin: 20px 30px 0;
  padding: 10px 15px;
  border: 1px solid #8D7F81;
  border-radius: 50px;
  font-size: 12px;
  color: #8D7F81 !important;
  background-image:
    url(../assets/Png/Common/ic_arrow_dropdown.png),
    linear-gradient(to left, #8D7F81, #8D7F81);
  background-size: 18px, 1px 22px;
  background-position: 97% center, 89% center;
  outline: none;
  &:focus { color: #8D7F81 !important; }
}
</style>
